import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps, InspectorControls, RichText, InnerBlocks } from '@wordpress/block-editor';
import { PanelBody, TextControl, ColorPicker, ToggleControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

registerBlockType('puroclean/cards-group', {
    edit({ attributes, setAttributes }) {
        const {
            showContentOnMobile,
            backgroundColor, 
            textColor 
        } = attributes;

        const blockProps = useBlockProps({
            className: 'cards-group-block'
        });

        // Add custom CSS to make cards display horizontally in editor and grow like frontend
        const editorStyles = `
            /* Card grid layout – only the first-level list inside the wrapper */
            .cards-group-block .flex.flex-row.flex-wrap > .block-editor-inner-blocks > .block-editor-block-list__layout {
                display: flex !important;
                flex-direction: row !important;
                flex-wrap: wrap !important;
                gap: 2rem !important;
                align-items: stretch !important;
            }
            
            /* Style the direct card blocks inside that list - allow them to grow */
            .cards-group-block .flex.flex-row.flex-wrap > .block-editor-inner-blocks > .block-editor-block-list__layout > .block-editor-block-list__block {
                flex: 1 1 420px !important;
                min-width: 420px !important;
                margin: 0 !important;
                display: flex !important;
                flex-direction: column !important;
            }
            
            /* Extra selector when Gutenberg puts data-type on the wrapper */
            .cards-group-block .flex.flex-row.flex-wrap > .wp-block[data-type="puroclean/card-content"] {
                flex: 1 1 300px !important;
                min-width: 300px !important;
                margin: 0 !important;
                display: flex !important;
                flex-direction: column !important;
            }
            
            /* Make the card content itself grow to fill the available height */
            .cards-group-block .flex.flex-row.flex-wrap .wp-block[data-type="puroclean/card-content"] > .wp-block-puroclean-card-content {
                flex: 1 !important;
                display: flex !important;
                flex-direction: column !important;
                height: 100% !important;
            }
            
            /* Ensure the card content div also grows */
            .cards-group-block .flex.flex-row.flex-wrap .wp-block[data-type="puroclean/card-content"] .bg-secondary-900 {
                flex: 1 !important;
                display: flex !important;
                flex-direction: column !important;
                min-height: 320px !important;
            }
        `;

        return (
            <>
                <style>{editorStyles}</style>
                <InspectorControls>
                    <PanelBody title={__('Section Settings', 'puroclean')}>
                        <ToggleControl
                            label={__('Show Content on Mobile', 'puroclean')}
                            help={__('Display card content on mobile devices (default: icons and titles only)', 'puroclean')}
                            checked={showContentOnMobile}
                            onChange={(value) => setAttributes({ showContentOnMobile: value })}
                        />
                    </PanelBody>
                    <PanelBody title={__('Styling', 'puroclean')}>
                        <div style={{ marginBottom: '16px' }}>
                            <label>{__('Background Color', 'puroclean')}</label>
                            <ColorPicker
                                color={backgroundColor}
                                onChange={(value) => setAttributes({ backgroundColor: value })}
                            />
                        </div>
                        <div>
                            <label>{__('Text Color', 'puroclean')}</label>
                            <ColorPicker
                                color={textColor}
                                onChange={(value) => setAttributes({ textColor: value })}
                            />
                        </div>
                    </PanelBody>
                </InspectorControls>

                <div {...blockProps}>
                    {/* Desktop Version */}
                    <div className="cards-group-desktop py-16" style={{ backgroundColor, color: textColor }}>
                        <div className="container max-w-content mx-auto px-4">
                            <div className="flex flex-row flex-wrap gap-8">
                                <InnerBlocks
                                    allowedBlocks={['puroclean/card-content']}
                                    template={[
                                        ['puroclean/card-content'],
                                        ['puroclean/card-content'],
                                        ['puroclean/card-content']
                                    ]}
                                    renderAppender={InnerBlocks.ButtonBlockAppender}
                                    templateInsertUpdatesSelection={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    },
    save() {
        return <InnerBlocks.Content />;
    }
}); 